import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Tab, Nav } from "react-bootstrap";
import GridTab from "./GridTab";
import AddCandidate from "./AddCandidate";
import ListTab from "./ListTab";
import { connect, useDispatch } from "react-redux";
import { getCandidates } from "../../../store/actions/Candidates/candidateActions";
import { withRouter } from "../../../App";
import { getLoggedInUser, getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import { SVGICON } from "../../constant/theme";



const Candidate = ({ token, loggedInUser, candidateSources, candidateStatus }) => {
  const userdata = useRef();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCandidates(token));
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Tab.Container defaultActiveKey={"List"}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="heading mb-0">Candidates</h4>
              <div className="d-flex align-items-center">
                <Nav
                  as="ul"
                  className="nav nav-pills mix-chart-tab user-m-tabe"
                  id="pills-tab"
                >
                  <Nav.Item as="li" className="nav-item" role="presentation">
                    <Nav.Link
                      as="button"
                      className="nav-link"
                      eventKey={"List"}
                    >
                      {SVGICON.List}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li" className="nav-item">
                    <Nav.Link
                      as="button"
                      className="nav-link"
                      eventKey={"Grid"}
                    >
                      {SVGICON.GridDots}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Link
                  to
                  className="btn btn-primary btn-sm ms-2"
                  onClick={() => userdata.current.showEmployeModal()}
                >
                  + Add Candidate
                </Link>
              </div>
            </div>
            <div className="col-xl-12 active-p">
              <Tab.Content>
                <Tab.Pane eventKey={"Grid"}>
                  <GridTab />
                </Tab.Pane>
                <Tab.Pane eventKey={"List"}>
                  <ListTab title="Candidate List" />
                </Tab.Pane>
              </Tab.Content>
            </div>
          </Tab.Container>
        </div>
      </div>
      <AddCandidate ref={userdata} Title="Add Candidate" candidateSources={candidateSources} token={token} loggedInUser={loggedInUser} candidateStatus={candidateStatus}/>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    loggedInUser: getLoggedInUser(state),
    candidateSources: state?.dropDownValues?.dropDownValues?.candidateSources || [],
    candidateStatus: state?.dropDownValues?.dropDownValues?.candidateStatus || [],
    employmentTypes: state?.dropDownValues?.dropDownValues?.employmentTypes || [],
    visaTypeValues: state?.dropDownValues?.dropDownValues?.visaTypeList || [],
    qualification: state?.dropDownValues?.dropDownValues?.qualification || [],
    skills: state?.dropDownValues?.dropDownValues?.skills || [],
    jobTitle: state?.dropDownValues?.dropDownValues?.jobTitle || []
  };
};

export default withRouter(connect(mapStateToProps)(Candidate));
